// extracted by mini-css-extract-plugin
export default {"form":"styles_form__Cg3M0","vertical":"styles_vertical__YK1A-","horizontal":"styles_horizontal__b9u9T"};